export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

export const SURFACES: PaletteEntry[] = [
  {
    name: "canvas",
    utility: "bg-canvas",
    hexLight: "oklch(96.7% 0.001 286.375)",
    hexDark: "oklch(14.1% 0.005 285.823)",
  },
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#ffffff",
    hexDark: "oklch(14.1% 0.005 285.823)",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "oklch(98.5% 0 0)",
    hexDark: "oklch(21% 0.006 285.885)",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "oklch(92% 0.004 286.32)",
    hexDark: "oklch(27.4% 0.006 286.033)",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "oklch(44.2% 0.017 285.786)",
    hexDark: "oklch(87.1% 0.006 286.286)",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "oklch(14.1% 0.005 285.823)",
    hexDark: "oklch(98.5% 0 0)",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "oklch(55.2% 0.016 285.938)",
    hexDark: "oklch(70.5% 0.015 286.067)",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "oklch(51.1% 0.262 276.966)",
    hexDark: "oklch(67.3% 0.182 276.935)",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "oklch(96.2% 0.018 272.314)",
    hexDark: "oklch(25% 0.06 277)",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "oklch(45.7% 0.24 277.023)",
    hexDark: "oklch(78.5% 0.115 274.713)",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "#fcd34d",
    hexDark: "#fcd34d",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "#fffaea",
    hexDark: "#2f2b21",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "oklch(76% 0.165 82)",
    hexDark: "oklch(93% 0.13 95)",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "oklch(64% 0.22 25)",
    hexDark: "oklch(72% 0.20 22)",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "oklch(96% 0.025 25)",
    hexDark: "oklch(22% 0.05 22)",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "oklch(55% 0.20 25)",
    hexDark: "oklch(82% 0.18 22)",
  },
];

/** Chart mark colors for strong / okay / weak results. Pair with a text label. */
export const CHART = [
  {
    name: "chart-strong",
    utility: "bg-chart-strong / stroke-chart-strong",
    hexLight: "oklch(58.5% 0.233 277.117)",
    hexDark: "oklch(67.3% 0.182 276.935)",
  },
  {
    name: "chart-okay",
    utility: "bg-chart-okay",
    hexLight: "oklch(76% 0.165 82)",
    hexDark: "oklch(66.5% 0.145 82)",
  },
  {
    name: "chart-weak",
    utility: "bg-chart-weak",
    hexLight: "oklch(64% 0.22 25)",
    hexDark: "oklch(56% 0.19 25)",
  },
];

export const FONTS = {
  display: "Inter",
  body: "Inter",
};
